const useExportFileTypePopupData = ({ popupData, closePopup }) => {
  const { handleSelectedOption } = popupData ?? {};

  const handleOptionClick = (event, option) => {
    event.preventDefault();
    handleSelectedOption(option);
    closePopup();
  };

  return {
    handleOptionClick,
  };
};

export default useExportFileTypePopupData;
